require("-!style!css!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Popover.vue")
module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Popover.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Popover.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/Popover.vue
 ** module id = 121
 ** module chunks = 0
 **/